var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"title mb-3"},[_vm._v("Видео урока")]),(_vm.videoUrl)?_c('youtube-embed',{attrs:{"link":_vm.videoUrl,"height":_vm.height}}):_c('v-alert',{attrs:{"type":"info"}},[_vm._v("Видео урока еще не готово")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }